<script>
    import { appManager } from "./AppManagerStore";
    import { _ } from "svelte-i18n";
</script>

<section id="cycling" class="bg-light">
    <div class="container">
        <div class="row justify-content-between align-items-center">
            <div class="col-12 col-md-6 col-lg-5 order-md-1">
                <div class="row">
                    <div class="col-12 mr-n5">
                        <img
                            src="{$appManager.PublicUrl}img/screenshots/cycling/cycling1.png"
                            alt="..."
                            class="img-fluid mb-4 rounded" />
                    </div>
                    <div class="col-12 mt-8">
                        <img
                            src="{$appManager.PublicUrl}img/screenshots/cycling/cycling3.png"
                            alt="..."
                            class="img-fluid mb-4 rounded" />
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 order-md-2 pt-md-12">
                <span class="badge rounded-pill bg-primary-soft mb-1">
                    <span class="h6 text-uppercase">
                        {$_("sustainable.badge.label")}
                    </span>
                </span>
                <h1>{$_("sustainable.header.title")}<br><span class="text-primary">{$_("sustainable.header.highlightedTitle")}</span></h1>
                <p class="fs-lg text-muted mb-6">
                    {$_("sustainable.description.part1")}
                </p>
            
                <p class="fs-lg text-muted mb-6">
                    {$_("sustainable.description.part2")}
                </p>
            
                <p class="fs-lg text-muted mb-6">
                    {$_("sustainable.description.part3")}
                </p>
            
                <h2>{$_("sustainable.section.title")}</h2>
            
                <p class="fs-lg text-muted mb-6">
                    {$_("sustainable.section.description.part1")}
                </p>
            
                <p class="fs-lg text-muted mb-6">
                    {$_("sustainable.section.description.part2")}
                </p>            

                <p class="fs-lg text-muted mb-6">
                    {$_("sustainable.cta.part1")}
                    <a href="{$appManager.PublicUrl}contact"
                        >{$_("sustainable.cta.part2")}</a
                    >.
                </p>

                <p class="mb-7 mb-md-9">
                    <a
                        class="btn btn-primary shadow lift"
                        href="{$appManager.PublicUrl}contact">
                        {$_("general.contactus")}
                        <i class="fe fe-arrow-right ms-3" />
                    </a>
                </p>
            </div>
        </div>
    </div>
</section>
